import {
    setSliceIsLoadingLanguage,
    setSliceLanguageList,
    setSliceVoiceList,
    setSliceVoiceStyleList,
    setSliceLanguageValue,
    setSliceVoiceValue,
    setSliceVoiceStyleValue,
    setSlicePreviewBtnStatus,
    setSliceTextToVideoStep,
    setSliceTextToVideoStepList,
    setSliceSelectTab,
    setSliceAll,
    defaultTextToVideoState,
    setSliceSceneTextList,
    setSliceSpiderData,
    setSliceProductMediaList,
    setSliceProductName,
    setSliceProductDescription,
    setSliceFreeNumCreationInfo,
    setSliceMediaSource,
    setSliceRatio,
    setSliceScriptPasteText,
} from '../slices/FJSliceTextToVideo';
import FJTextToSpeechManager from '../../store/FJTextToSpeechManager';
import FJConstant from '../../constants/FJConstant';
import FJUtil from '../../util/FJUtil';
import { FJ_EVENT_TYPE } from '../../constants/FJEvenTypeConstant';
import { FJSpeechRealTimePreview } from '../../lib/fj-speech.mjs';
import FJNetworkStore from '../../store/FJNetworkStore';
import FJMessageStore from '../../store/FJMessageStore';
import FJLocalStore from '../../store/FJLocalStore';
import {
    LANGUAGE_WORDS_PER_MINUTE,
    MAN_SCENE_NUM,
    PRODUCT_URL_TO_VIDEO_MAX_IMAGE_NUM,
    TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE,
    TEXT_TO_VIDEO_PRICE,
    TEXT_TO_VIDEO_RATIO_LIST,
    TEXT_TO_VIDEO_STEP_LIST,
} from '../../config/dataConfig/FJTextToVideoDataConfig';
import FJTranslateLanguage from '../../config/dataConfig/FJTranslateLanguage';
import FJActionModal from './FJActionModal';
import FJTextToImageDataConfig from '../../config/dataConfig/FJTextToImageDataConfig';
import { TEXT_TO_VIDEO_POLLING_INTERVAL, UPLOAD_FILE_TYPE_PRODUCE_IMAGE } from '../../config/dataConfig/FJGenerateData';
import FJS3Config from '../../config/FJS3Config';
import FJConfig from '../../config/FJConfig';
import FJActionEditPage from './FJActionEditPage';
import FJAppConstant from '../../constants/FJAppConstant';
import FJActionCommon from './FJActionCommon';
import FJImageStore from '../../store/FJImageStore';
import FJEvent from '../../store/FJEvent';
import FJLoadLocalforageStore from '../../store/FJLoadLocalforageStore';
import { setAppTypeAction } from '../slices/FJSliceCommon';
import FJTextToVideoStore from '../../store/FJTextToVideoStore';
import localforage from 'localforage';
import FJTabCommunication from '../../core/FJTabCommunication';
let f_initMediaSource = {};
let f_initRatio = null;
let f_isInitRatio = {};
let f_speechRealTimePreviewTimestamp = null;
let f_FJSpeechRealTimePreview = null;
let f_StateCache = {};

let f_pptToVideoCache = {};
let f_spiderCache = {};
let f_pptScriptCache = {};
let f_sceneTextLang = 'en';
// 解析google返回数组数据
const _parseGoogleArrData = data => {
    const arrString = data.substring(data.indexOf('['), data.lastIndexOf(']') + 1);

    try {
        return JSON.parse(arrString)
            .filter(i => !!i.trim())
            .slice(0, 50);
    } catch (e) {
        const arrSplitSymbols = [`"`, `'`];
        const mixArrSymbols = [`",`, `',`];
        console.log('parse2');
        //容错处理机制
        return arrString
            .slice(1, -1)
            .trim()
            .split(/",|',/)
            .map(text => {
                let newText = text.trim();
                if (arrSplitSymbols.includes(newText[0])) {
                    newText = newText.slice(1);
                }
                if (mixArrSymbols.includes(newText.slice(-2))) {
                    newText = newText.slice(0, -2);
                }
                if (arrSplitSymbols.includes(newText[newText.length - 1])) {
                    newText = newText.slice(0, -1);
                }

                return newText;
            })
            .filter(i => !!i.trim())
            .slice(0, 50);
    }
};

// 解析google返回对象数据
const _parseGoogleObjData = data => {
    try {
        return JSON.parse(data);
    } catch (e) {
        const objString = data.substring(data.indexOf('{'), data.lastIndexOf('}') + 1);

        return FJUtil.parseJSON(objString);
    }
};
// 生成场景文本列表(计算时长)
const _getSceneTextList = (textArr, lang) => {
    return textArr.map(text => {
        const duration = (FJUtil.getTextLength(text) / (LANGUAGE_WORDS_PER_MINUTE[lang] || 900)) * 60;
        return {
            id: FJUtil.createSimpleId(),
            text,
            duration: Math.floor(duration * 10) / 10,
        };
    });
};
// 翻译成英语
const _translatePrompts = async prompts => {
    const isEnglish = FJUtil.isEnglish(prompts[0]);

    if (isEnglish) {
        return prompts;
    }
    const postData = prompts.map(prompt => ({ text: prompt }));
    const result = await FJNetworkStore.translateValueToLanguage(postData);
    const usePrompts = result.map(i => i.translations[0].text);

    return usePrompts;
};
// AI生成图片
const _batchAiTextToImage = async (textArr, options, dispatch) => {
    const { ratio, curStyle } = options;
    const usePrompts = await _translatePrompts(textArr);
    const idsInfo = await FJNetworkStore.batchTextToImage({
        prompts: JSON.stringify(usePrompts),
        model_type: FJTextToImageDataConfig.V1_MODELS[0].value,
        ratio: ratio,
        style: curStyle.name === 'none' ? '' : curStyle.name,
        prompt_val: curStyle.value,
        generateNumber: 1,
        input_prompt: JSON.stringify(textArr),
    });

    const { data: taskIds, code } = idsInfo;
    if (code == 401) {
        FJUtil.getCredits(FJTextToVideoStore.getAppType());
        return;
    } else if (code === 214) {
        FJUtil.login();
        return;
    } else if (code === 501) {
        dispatch(FJActionModal.showServerBusyModalAction());
        return;
    }
    const taskResultInfo = await FJUtil.pollingTasks(taskIds, TEXT_TO_VIDEO_POLLING_INTERVAL);

    return taskIds.map(id => {
        const { data } = taskResultInfo[id];
        const mediaInfo = data['out_put'][0];
        const url = FJS3Config.S3_SERVER_HOST + FJConfig.textToImageResultImageKey + mediaInfo.result;
        const mediaId = mediaInfo.result.split('.').shift();
        return { type: 'IMAGE', url: url, id: mediaId, source: 'WEB' };
    });
};
/* // 谷歌生成图片
const _batchGoogleTextToImage = async (textArr, options) => {
    const { style, ratio } = options;
    const idInfo = await FJNetworkStore.geminiGenerateImage({
        style,
        ratio,
        prompt: JSON.stringify(textArr),
    });
    const { event_id } = idInfo;
    const taskResultInfo = await FJUtil.pollingTasks([event_id], TEXT_TO_VIDEO_POLLING_INTERVAL);
    const { data } = taskResultInfo[event_id];
    const result = JSON.parse(data['out_put'][0].info);
    return result.map(item => ({ type: 'IMAGE', url: FJS3Config.S3_SERVER_HOST + item + '?cc=media' }));
}; */

const _getImageList = async (imgDescList, textToImageStyle, ratio, dispatch) => {
    // if (textToImageStyle.type === 'chrome') {
    //     return await _batchGoogleTextToImage(imgDescList, {
    //         style: textToImageStyle.value,
    //         ratio: ratio.ratioValue,
    //     });
    // } else {
    return await _batchAiTextToImage(
        imgDescList,
        {
            ratio: ratio.name,
            curStyle: textToImageStyle,
        },
        dispatch,
    );
    // }
};

// ppt 转视频
const _pptToVideo = async (file, fileId) => {
    let fail_reason = '';
    let message = '';
    let file_name = '';
    let pptInfo = null;
    let isSuccess = false;
    try {
        const id = fileId || (await FJUtil.hashEncode(file));
        if (f_pptToVideoCache[id]) {
            return f_pptToVideoCache[id];
        }
        const fileSuffix = FJUtil.getFileSuffix(file.name);
        const key = FJConfig.pptUploadFileKey + `${id}.${fileSuffix}`;
        const uploadStatus = await FJImageStore.upLoadFileToS3Async(file, key);
        if (!uploadStatus) return;
        const url = FJS3Config.S3_SERVER_HOST + key;
        file_name = url;
        const idInfo = await FJNetworkStore.pptToVideo(url);
        const { event_id } = idInfo;
        const resultInfo = await FJUtil.pollingTasks([event_id], TEXT_TO_VIDEO_POLLING_INTERVAL);
        const result = resultInfo[event_id];
        const { data = [], type } = result;
        if (type === FJConstant.ERROR) {
            if (data['error_msg'] === 'max page limit') {
                FJMessageStore.addMessage(FJLocalStore._('please-upload-a-file-of-up-to-50-pages'), 'error');
            } else {
                FJMessageStore.addMessage(FJLocalStore._('oops-an-error-occurred-please-try-again'), 'error');
            }
            message = data['error_msg'];
            fail_reason = 'others';
        } else if ((type === FJConstant.SUCCESS, data['out_put'])) {
            const pptArr = JSON.parse(data['out_put'][0].info);
            const textString = pptArr
                .reduce((acc, cur) => {
                    return acc + cur.text;
                }, '')
                .trim();
            if (pptArr?.length === 0) {
                fail_reason = 'empty_or_image_only_content';
                FJMessageStore.addMessage(FJLocalStore._('oops-an-error-occurred-please-try-again'), 'error');
            } else if (!textString) {
                fail_reason = 'empty_or_image_only_content';
                FJMessageStore.addMessage(FJLocalStore._('oops-an-error-occurred-please-try-again'), 'error');
            } else {
                pptArr && (f_pptToVideoCache[id] = pptArr);
                pptInfo = pptArr;
                isSuccess = true;
            }
        }
    } catch (error) {
        message = error.message;
        fail_reason = 'others';
    } finally {
        !isSuccess &&
            FJUtil.eaLog('ai_ppt_parse_failed', {
                file_name,
                fail_reason,
                message,
            });
    }
    return pptInfo;
};
//检查登录
const _checkLogin = async dispatch => {
    const userSpaceType = await FJUtil.checkUserSpace({
        errorCallback: () => {
            FJMessageStore.addMessage(FJLocalStore._('oops-an-error-occurred-please-try-again'), 'error');
        },
    });
    if (userSpaceType > 0) {
        dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
        dispatch(FJActionModal.hideGenerateLoadingModalAction());
        return false;
    }
    return true;
};

const _addProductUrls = async images => {
    const imageList = [];
    for (const item of images) {
        if (imageList.length >= PRODUCT_URL_TO_VIDEO_MAX_IMAGE_NUM) break;
        const blob = await FJUtil.getBlobByUrl(item.url);
        const fileId = await FJUtil.hashEncode(blob);
        const image = await FJUtil.loadImageFileAsync(blob);
        image &&
            imageList.push({
                id: fileId,
                type: 'IMAGE',
                url: item.url,
                width: image.width,
                height: image.height,
                source: 'WEB',
            });
    }
    return imageList;
};
// 抓取页面/商品数据
const _spiderPage = async (url, type = 'article') => {
    if (f_spiderCache[url]) {
        return f_spiderCache[url];
    }
    const spiderData = await FJNetworkStore.spiderPageByURL({ url, type });
    if (spiderData?.article && spiderData?.article?.articleBody) {
        f_spiderCache[url] = spiderData.article;
        return spiderData.article;
    }
    if (spiderData?.product && spiderData?.product?.description && spiderData?.product?.name) {
        f_spiderCache[url] = spiderData.product;
        return spiderData?.product;
    }
    return;
};
const _getLanguageInfo = async text => {
    const languageInfo = await FJNetworkStore.getLanguageInfoByText(text);
    const lang = languageInfo[0]['language'];
    f_sceneTextLang = lang;
    return lang;
};
// 生成ppt脚本
const _generatePptScript = async (pptResult, id) => {
    if (f_pptScriptCache[id]) {
        return f_pptScriptCache[id];
    }
    const textArr = pptResult.map(i => i.text);
    const detectLang = textArr
        .reduce((acc, cur) => {
            return acc + cur;
        }, '')
        .substring(0, 100);
    const lang = await _getLanguageInfo(detectLang);
    let aiLanguage = FJTranslateLanguage[lang] || lang;
    const chatData = await FJNetworkStore.getChatData({
        prompt: JSON.stringify(textArr),
        type: 7,
        language: aiLanguage,
    });
    const textList = _parseGoogleArrData(chatData);
    let scriptList = _getSceneTextList(textList, lang);

    const result = scriptList.map((item, idx) => ({
        ...item,
        mediaInfo: {
            type: 'IMAGE',
            url: FJS3Config.S3_SERVER_HOST + FJConfig.pptResultKey + pptResult[idx].image,
            id: pptResult[idx].image.split('.').shift(),
            source: 'WEB',
        },
    }));
    f_pptScriptCache[id] = result;
    return result;
};

const FJActionTextToVideo = {
    /**
     * @description 获取语言列表
     * @returns {(function(*, *))|*}
     */
    getAndSetLanguageAndVoiceListAction: function (callback) {
        return async (dispatch, getState) => {
            const { languageList, isLoadingLanguage } = getState().textToVideo;
            if (isLoadingLanguage || languageList.length > 0) {
                callback && callback(true);
                return;
            }
            dispatch(setSliceIsLoadingLanguage(true));
            const { voiceObj, styleObj, language, langList } = await FJTextToSpeechManager.getListInfo();
            if (voiceObj && styleObj && language && langList) {
                dispatch(setSliceIsLoadingLanguage(false));
                dispatch(setSliceLanguageList(langList));
                dispatch(FJActionTextToVideo.updateTTSLanguageInfoAction(language));

                callback && callback(true);
            } else {
                dispatch(setSliceIsLoadingLanguage(false));
                callback && callback(false);
            }
        };
    },
    /**
     * @description 更新TTS的 声音，声音风格的列表和其value，以及语言的value
     * @param languageValue
     * @returns {(function(*): void)|*}
     */
    updateTTSLanguageInfoAction: function (languageValue) {
        return dispatch => {
            const { voiceList, voiceStyleList, voiceValue, voiceStyleValue } =
                FJTextToSpeechManager.getTTSInfoByLang(languageValue);
            dispatch(setSliceVoiceList(voiceList));
            dispatch(setSliceVoiceStyleList(voiceStyleList));
            dispatch(setSliceLanguageValue(languageValue));
            dispatch(setSliceVoiceValue(voiceValue));
            dispatch(setSliceVoiceStyleValue(voiceStyleValue));
        };
    },
    /**
     * @description 更新TTS的 声音风格的列表和其value
     * @param voiceValue
     * @returns {(function(*): void)|*}
     */
    updateTTSInfoByVoiceAction: function (voiceValue) {
        return dispatch => {
            const { voiceStyleList, voiceStyleValue } = FJTextToSpeechManager.getTTSInfoByVoice(voiceValue);
            dispatch(setSliceVoiceStyleList(voiceStyleList));
            dispatch(setSliceVoiceStyleValue(voiceStyleValue));
        };
    },
    /**
     * @description 预览文字转语音
     * @param text
     * @param options
     * @returns {(function(*, *): Promise<void>)|*}
     */
    previewTTSAction: function (text, options) {
        return async (dispatch, getState) => {
            if (!FJUtil.isLogin() && !FJUtil.isLocalhost()) {
                let __retry = () => {
                    window.setTimeout(() => {
                        const useText = FJUtil.filterEmoji(text);
                        dispatch(this.previewTTSAction(useText, options));
                    }, 300);
                };

                FJUtil.anonymousSignUp()
                    .then(__retry)
                    .catch(e => console.log(e));
                return;
            }

            FJEvent.dispatch(FJ_EVENT_TYPE.STOP_PREVIEW_VOICE_IN_TTS);

            const state = getState();
            const { languageValue, voiceValue, voiceStyleValue, previewBtnStatus } = state.textToVideo;
            const { speed, pitch } = options;
            // preview
            if (previewBtnStatus === FJConstant.IDLE) {
                f_speechRealTimePreviewTimestamp = Date.now();
                const timestamp = f_speechRealTimePreviewTimestamp;
                dispatch(setSlicePreviewBtnStatus(FJConstant.LOADING));
                f_FJSpeechRealTimePreview = new FJSpeechRealTimePreview();

                let token;
                try {
                    // const tokenUrl = process.env.TARGET_ENV !== 'localhost' ? '/subtitle/get-token' : undefined;
                    token = await FJNetworkStore.getVoiceServiceToken();
                } catch (e) {
                    if (timestamp === f_speechRealTimePreviewTimestamp) {
                        dispatch(setSlicePreviewBtnStatus(FJConstant.IDLE));
                        FJMessageStore.addMessage(FJLocalStore._('failed-to-preview-the-audio'), 'error');
                        return;
                    }
                }

                if (timestamp !== f_speechRealTimePreviewTimestamp || !f_FJSpeechRealTimePreview) {
                    dispatch(setSlicePreviewBtnStatus(FJConstant.IDLE));
                    return;
                }

                try {
                    const audioData = await f_FJSpeechRealTimePreview.realTimePreview(FJUtil.getPreviewText(text), {
                        languageValue: languageValue,
                        voiceValue: voiceValue,
                        voiceStyleValue: voiceStyleValue,
                        voiceSpeed: speed,
                        pitch: pitch,
                        token: token,
                        onAudioEndCallback: () => {
                            if (timestamp === f_speechRealTimePreviewTimestamp) {
                                dispatch(setSlicePreviewBtnStatus(FJConstant.IDLE));
                            }
                        },
                        onAudioStartCallback: () => {
                            if (timestamp === f_speechRealTimePreviewTimestamp) {
                                dispatch(setSlicePreviewBtnStatus(FJConstant.PLAYING));
                            }
                        },
                    });
                    if (f_speechRealTimePreviewTimestamp === timestamp) {
                        if (audioData.byteLength === 0) {
                            FJMessageStore.addMessage(
                                FJLocalStore._('please-enter-the-text-consistent-with-the-selected-language'),
                                'warning',
                            );
                            dispatch(setSlicePreviewBtnStatus(FJConstant.IDLE));
                        }
                    }
                } catch (e) {
                    if (timestamp === f_speechRealTimePreviewTimestamp) {
                        console.log(e);
                        dispatch(setSlicePreviewBtnStatus(FJConstant.IDLE));
                        FJMessageStore.addMessage(FJLocalStore._('failed-to-preview-the-audio'), 'error');
                    }
                }
            } else {
                // stop preview
                dispatch(this.stopPreviewTTSAction());
            }
        };
    },
    /**
     * @description 停止预览
     * @returns {(function(*): void)|*}
     */
    stopPreviewTTSAction: function () {
        return dispatch => {
            dispatch(setSlicePreviewBtnStatus(FJConstant.IDLE));
            if (f_FJSpeechRealTimePreview) {
                f_FJSpeechRealTimePreview.stopRealTimePreview();
                f_FJSpeechRealTimePreview.stopPlayerSynthesizer();
            }
            f_speechRealTimePreviewTimestamp = null;
        };
    },
    onStepChangeAction: function (step) {
        return (dispatch, getState) => {
            const {
                selectTab,
                productName,
                productDescription,
                productMediaList,
                textToVideoStepList,
                textToVideoStep,
            } = getState().textToVideo;
            // 提示是否确认返回
            let isShowWarningModal = false;
            if (selectTab === FJAppConstant.PRODUCT_URL_TO_VIDEO) {
                isShowWarningModal =
                    step === FJConstant.STEP_TYPE_HOME &&
                    (productName.trim() || productDescription.trim() || productMediaList.length > 0);
            } else if (selectTab === FJAppConstant.PPT_TO_VIDEO) {
                isShowWarningModal = false;
            } else {
                if (textToVideoStepList.length === 3) {
                    isShowWarningModal = step === FJConstant.STEP_TYPE_HOME;
                } else {
                    isShowWarningModal =
                        (step === FJConstant.STEP_TYPE_HOME || step === FJConstant.STEP_TYPE_SCRIPTS_PASTE) &&
                        (textToVideoStep === FJConstant.STEP_TYPE_SCRIPTS_EDIT ||
                            textToVideoStep === FJConstant.STEP_TYPE_VIDEO_SETTINGS);
                }
            }
            if (isShowWarningModal) {
                dispatch(
                    FJActionModal.showWarningModalAction({
                        title: FJLocalStore._('getting-back-will-lose-content'),
                        content: FJLocalStore._(
                            'get-back-and-you-will-lose-the-current-content-are-you-sure-to-continue',
                        ),
                        footerDates: [
                            {
                                btnType: FJConstant.GRADIENT,
                                btnText: FJLocalStore._('continue'),
                                btnCallback: () => {
                                    dispatch(setSliceTextToVideoStep(step));
                                },
                            },
                            {
                                btnType: FJConstant.CANCEL,
                                btnText: FJLocalStore._('cancel'),
                                btnCallback: null,
                            },
                        ],
                    }),
                );
            } else {
                dispatch(setSliceTextToVideoStep(step));
            }
        };
    },
    onTabChangeAction: function (tab) {
        return (dispatch, getState) => {
            // 缓存当前状态 (各个工具之间状态独立)
            const preState = getState().textToVideo;
            f_StateCache[preState.selectTab] = preState;
            //freeNumCreationInfo 需要单独处理
            const freeInfo = { ...preState.freeNumCreationInfo };
            // 获取新的状态
            let newState = f_StateCache[tab] || defaultTextToVideoState;
            // 更新状态
            dispatch(
                setSliceAll({
                    ...newState,
                    freeNumCreationInfo: freeInfo,
                    languageList: preState.languageList,
                    voiceList: preState.voiceList,
                    voiceStyleList: preState.voiceStyleList,
                    voiceValue: preState.voiceValue,
                    voiceStyleValue: preState.voiceStyleValue,
                    languageValue: preState.languageValue,
                }),
            );
            dispatch(setSliceSelectTab(tab));
            dispatch(setAppTypeAction(tab));
            FJTextToVideoStore.setAppType(tab);
            if (!window.isEditPage) {
                const tag = FJLocalStore.currentTag();
                let linkTag = tag === 'en' ? `` : `/${tag}`;
                const { origin, search } = window.location;
                const href = FJUtil.getAIToolHref(tab);
                FJUtil.changeLocation(`${origin}${linkTag}${href}${search}`);
                document.title = FJLocalStore._(tab) + ' | FlexClip';
            }
        };
    },

    // ttfv生成脚本
    onTextToScriptAction: function () {
        return async (dispatch, getState) => {
            const { slateEditorNodes, freeNumCreationInfo, textToVideoStep } = getState().textToVideo;
            const creditNumber = getState().common.creditNumber;
            const scriptInputValue = FJUtil.getTextBySlateNodes(slateEditorNodes);
            // 更新step列表
            if (!scriptInputValue) {
                FJMessageStore.addMessage(FJLocalStore._('please-enter-the-description-first'), 'error');
                return;
            }

            dispatch(FJActionModal.showGenerateLoadingModalAction(FJLocalStore._('generating...')));

            try {
                const isLogin = await _checkLogin(dispatch);
                if (!isLogin) return;
                const quotaInfo = this.getQuotaInfo({
                    type: TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE.TEXT_TO_SCRIPT,
                    freeNumCreationInfo,
                    creditNumber,
                });
                const { useCredits, deductType, useFreeTimes } = quotaInfo;

                FJUtil.eaLog('text_to_full_video_generate_scripts_click', {
                    script_prompt: scriptInputValue,
                    step_location: textToVideoStep === FJConstant.STEP_TYPE_HOME ? 'home' : 'edit script',
                    'credit&free': useFreeTimes ? 'free' : 'credit',
                    page: window.isEditPage ? 'editor' : 'tools page',
                });

                if (!quotaInfo.isEnough) {
                    FJUtil.getCredits(FJTextToVideoStore.getAppType());

                    dispatch(FJActionModal.hideGenerateLoadingModalAction());
                    return;
                }
                const lang = await _getLanguageInfo(scriptInputValue.substring(0, 100));
                let aiLanguage = FJTranslateLanguage[lang] || lang;
                const chatData = await FJNetworkStore.getChatData({
                    prompt: scriptInputValue,
                    type: 1,
                    language: aiLanguage,
                });
                const textList = _parseGoogleArrData(chatData);
                const scriptList = _getSceneTextList(textList, lang);
                dispatch(FJActionModal.hideGenerateLoadingModalAction());
                const deductResult = await FJNetworkStore.payCredit(useCredits, deductType);
                if (deductResult) {
                    FJUtil.updateAllCreditInfo(useFreeTimes);
                } else {
                    dispatch(this.onErrorAction('generating-script-failed-please-try-again'));
                    return;
                }
                // 生成脚本
                dispatch(setSliceSceneTextList(scriptList));
                const newStepList = TEXT_TO_VIDEO_STEP_LIST.filter(
                    item => item.type !== FJConstant.STEP_TYPE_SCRIPTS_PASTE,
                );
                dispatch(setSliceTextToVideoStepList(newStepList));
                dispatch(setSliceTextToVideoStep(FJConstant.STEP_TYPE_SCRIPTS_EDIT));
            } catch (error) {
                console.log('error', error);
                dispatch(this.onErrorAction('generating-script-failed-please-try-again'));
            }
        };
    },
    // 粘贴脚本入口
    gotoPasteScriptAction: function () {
        return dispatch => {
            dispatch(setSliceTextToVideoStepList(TEXT_TO_VIDEO_STEP_LIST));
            dispatch(setSliceTextToVideoStep(FJConstant.STEP_TYPE_SCRIPTS_PASTE));
        };
    },
    /**
     * @description 更新场景文本列表
     * @param {*} id
     * @param {*} options
     * @returns
     */
    onUpdateSceneTextListAction: function (id, options) {
        return (dispatch, getState) => {
            const { type, textValue = '', moveInsertIndex, splitIdx, ignoreFocus = false } = options;
            let sceneTextList = getState().textToVideo.sceneTextList;
            let newList = [...sceneTextList];
            let item = newList.find(item => item.id === id);
            const itemIdx = newList.findIndex(item => item.id === id);
            if (type === FJ_EVENT_TYPE.EDIT) {
                newList[itemIdx] = { ...item, text: textValue };
            } else if (type === FJ_EVENT_TYPE.ADD) {
                if (newList.length >= MAN_SCENE_NUM) {
                    FJMessageStore.addMessage(FJLocalStore._('you-can-add-up-to-50-scenes'), 'error');
                    return;
                }
                let tempId = FJUtil.createSimpleId();
                if (itemIdx === -1) {
                    newList.push({ id: tempId, text: textValue });
                } else {
                    newList.splice(itemIdx + 1, 0, { id: tempId, text: textValue });
                }
                !ignoreFocus &&
                    FJUtil.wait(0).then(() => {
                        FJEvent.dispatch(FJ_EVENT_TYPE.SET_SCENE_FOCUS, {
                            focusId: tempId,
                        });
                    });
            } else if (type === FJ_EVENT_TYPE.DELETE) {
                if (newList.length <= 1) {
                    return;
                }
                newList.splice(itemIdx, 1);
            } else if (type === FJ_EVENT_TYPE.MOVE) {
                const insertIndex = moveInsertIndex < 1 ? 0 : moveInsertIndex;
                if (insertIndex === itemIdx || insertIndex - 1 === itemIdx) return;
                newList.splice(insertIndex, 0, item);
                const deleteIndex = insertIndex > itemIdx ? itemIdx : itemIdx + 1;
                newList.splice(deleteIndex, 1);
            } else if (type === FJ_EVENT_TYPE.MERGE_PREV) {
                const prevItem = newList[itemIdx - 1];
                // 检查是否需要添加空格
                const needSpace =
                    prevItem.text.trim().length > 0 &&
                    item.text.trim().length > 0 &&
                    !prevItem.text.endsWith(' ') &&
                    !item.text.startsWith(' ');

                newList[itemIdx - 1] = {
                    ...prevItem,
                    text: prevItem.text + (needSpace ? ' ' : '') + item.text,
                };

                newList.splice(itemIdx, 1);
                FJUtil.wait(0).then(() => {
                    FJEvent.dispatch(FJ_EVENT_TYPE.SET_SCENE_FOCUS, {
                        focusId: newList[itemIdx - 1].id,
                        cursorPosition: prevItem.text.length + (needSpace ? 1 : 0),
                    });
                });
            } else if (type === FJ_EVENT_TYPE.SPLIT) {
                if (newList.length >= MAN_SCENE_NUM) {
                    FJMessageStore.addMessage(FJLocalStore._('you-can-add-up-to-50-scenes'), 'error');
                    return;
                }
                const beforeCaret = item.text.substring(0, splitIdx);
                const afterCaret = item.text.substring(splitIdx);
                newList[itemIdx] = { ...item, text: beforeCaret };
                const id = FJUtil.createSimpleId();
                newList.splice(itemIdx + 1, 0, { id: id, text: afterCaret });

                FJUtil.wait(0).then(() => {
                    FJEvent.dispatch(FJ_EVENT_TYPE.SET_SCENE_FOCUS, { focusId: id });
                });
            }
            dispatch(setSliceSceneTextList(newList));
        };
    },
    /**
     * @description 分割脚本
     * @param {*} callback
     * @returns
     */
    onPasteToScriptEditAction: function () {
        return async (dispatch, getState) => {
            const { scriptPasteText } = getState().textToVideo;
            if (!scriptPasteText) {
                FJMessageStore.addMessage(FJLocalStore._('please-enter-the-script-first'), 'error');
                return;
            }
            dispatch(FJActionModal.showGenerateLoadingModalAction(FJLocalStore._('generating...')));

            try {
                const isLogin = await _checkLogin(dispatch);
                if (!isLogin) return;
                FJUtil.eaLog('text_to_full_video_script_next_click', {
                    script_text: scriptPasteText,
                    mode: 'paste mode',
                    page: window.isEditPage ? 'editor' : 'tools page',
                });

                const lang = await _getLanguageInfo(scriptPasteText.substring(0, 100));
                const chatData = await FJNetworkStore.getChatData({
                    prompt: scriptPasteText,
                    type: 2,
                });
                const textList = _parseGoogleArrData(chatData);

                const scriptList = _getSceneTextList(textList, lang);
                dispatch(FJActionModal.hideGenerateLoadingModalAction());
                dispatch(setSliceSceneTextList(scriptList));
                dispatch(setSliceTextToVideoStep(FJConstant.STEP_TYPE_SCRIPTS_EDIT));
            } catch (error) {
                console.log('error', error);
                dispatch(this.onErrorAction('oops-an-error-occurred-please-try-again'));
            }
        };
    },

    // 分析网站URL
    onAnalyzeUrlAction: function () {
        return async (dispatch, getState) => {
            // 更新step列表
            dispatch(FJActionModal.showGenerateLoadingModalAction(FJLocalStore._('generating...')));
            const { urlToVideoInput, freeNumCreationInfo } = getState().textToVideo;
            const creditNumber = getState().common.creditNumber;
            if (!urlToVideoInput) {
                dispatch(FJActionModal.hideGenerateLoadingModalAction());
                FJMessageStore.addMessage(FJLocalStore._('please-enter-the-url-first'), 'error');
                return;
            }
            let domain = FJUtil.getDomainFromUrl(urlToVideoInput);
            try {
                const isLogin = await _checkLogin(dispatch);
                if (!isLogin) return;
                const quotaInfo = this.getQuotaInfo({
                    type: TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE.ANALYSIS_URL,
                    freeNumCreationInfo,
                    creditNumber,
                });
                FJUtil.eaLog('blog_url_to_video_url_analyze_click', {
                    url: urlToVideoInput,
                    domain,
                    page: window.isEditPage ? 'editor' : 'tools page',
                });
                if (!quotaInfo.isEnough) {
                    FJUtil.getCredits(FJTextToVideoStore.getAppType());
                    dispatch(FJActionModal.hideGenerateLoadingModalAction());
                    return;
                }

                const spiderData = await _spiderPage(urlToVideoInput, 'article');
                if (!spiderData) {
                    dispatch(FJActionModal.hideGenerateLoadingModalAction());
                    FJMessageStore.addMessage(
                        FJLocalStore._('url-analysis-failed-please-try-again-or-use-another-url'),
                        'error',
                    );
                    FJUtil.eaLog('blog_url_to_video_url_analyze_complete', {
                        url: urlToVideoInput,
                        domain,
                        Success: false,
                        fail_reason: 'url analysis failed',
                        page: window.isEditPage ? 'editor' : 'tools page',
                    });
                    return;
                }
                let { articleBody, images } = spiderData;
                let resultImgs = [];
                if (images && images.length) {
                    resultImgs = await FJUtil.filterCanDownloadImages(images);
                }
                const lang = await _getLanguageInfo(articleBody.substring(0, 100));
                let aiLanguage = FJTranslateLanguage[lang] || lang;
                const chatData = await FJNetworkStore.getChatData({
                    prompt: articleBody,
                    type: 5,
                    language: aiLanguage,
                });
                const textList = _parseGoogleArrData(chatData);

                const scriptList = _getSceneTextList(textList, lang);
                const { useCredits, deductType, useFreeTimes } = quotaInfo;
                const deductResult = await FJNetworkStore.payCredit(useCredits, deductType);
                FJUtil.eaLog('blog_url_to_video_url_analyze_complete', {
                    url: urlToVideoInput,
                    domain,
                    Success: true,
                    page: window.isEditPage ? 'editor' : 'tools page',
                });
                if (deductResult) {
                    FJUtil.updateAllCreditInfo(useFreeTimes);
                } else {
                    FJUtil.eaLog('blog_url_to_video_url_analyze_complete', {
                        url: urlToVideoInput,
                        domain,
                        Success: false,
                        fail_reason: 'oops an error',
                        page: window.isEditPage ? 'editor' : 'tools page',
                    });
                    dispatch(this.onErrorAction('oops-an-error-occurred-please-try-again'));
                    return;
                }

                // 生成脚本
                dispatch(setSliceSceneTextList(scriptList));
                dispatch(setSliceSpiderData({ articleBody, images: resultImgs }));

                dispatch(FJActionModal.hideGenerateLoadingModalAction());
                const newStepList = TEXT_TO_VIDEO_STEP_LIST.filter(
                    item => item.type !== FJConstant.STEP_TYPE_SCRIPTS_PASTE,
                );
                dispatch(setSliceTextToVideoStepList(newStepList));
                dispatch(setSliceTextToVideoStep(FJConstant.STEP_TYPE_SCRIPTS_EDIT));
            } catch (error) {
                console.log('error', error);
                FJUtil.eaLog('blog_url_to_video_url_analyze_complete', {
                    url: urlToVideoInput,
                    domain,
                    Success: false,
                    fail_reason: 'oops an error',
                    page: window.isEditPage ? 'editor' : 'tools page',
                });
                dispatch(this.onErrorAction('oops-an-error-occurred-please-try-again'));
            }
        };
    },
    onAnalyzeUrlNextAction: function () {
        return async (dispatch, getState) => {
            const { urlToVideoInput } = getState().textToVideo;

            let domain = FJUtil.getDomainFromUrl(urlToVideoInput);
            FJUtil.eaLog('blog_url_to_video_next_click', {
                url: urlToVideoInput,
                domain,
                page: window.isEditPage ? 'editor' : 'tools page',
            });
            dispatch(setSliceTextToVideoStep(FJConstant.STEP_TYPE_VIDEO_SETTINGS));
        };
    },
    // 分析产品URL
    onAnalyzeProductUrlAction: function () {
        return async (dispatch, getState) => {
            const { productUrlToVideoInput } = getState().textToVideo;
            let domain = FJUtil.getDomainFromUrl(productUrlToVideoInput);
            try {
                if (!productUrlToVideoInput) {
                    FJMessageStore.addMessage(FJLocalStore._('please-enter-the-url-first'), 'error');
                    return;
                }
                dispatch(FJActionModal.showGenerateLoadingModalAction(FJLocalStore._('generating...')));

                const isLogin = await _checkLogin(dispatch);
                if (!isLogin) return;
                FJUtil.eaLog('ai_product_url_analyze_click', {
                    url: productUrlToVideoInput,
                    domain,
                    page: window.isEditPage ? 'editor' : 'tools page',
                });
                // const productCrawlerData = await _productCrawler(productUrlToVideoInput);
                const productCrawlerData = await _spiderPage(productUrlToVideoInput, 'product');
                if (!productCrawlerData) {
                    dispatch(this.onErrorAction('url-analysis-failed-please-try-again-or-use-another-url'));
                    FJUtil.eaLog('ai_product_url_analyze_complete', {
                        url: productUrlToVideoInput,
                        domain,
                        Success: false,
                        fail_reason: 'url analysis failed',
                        page: window.isEditPage ? 'editor' : 'tools page',
                    });
                    return;
                }
                const { description, images, name } = productCrawlerData;

                const imageList = await _addProductUrls(images);
                dispatch(setSliceProductName(name));
                dispatch(setSliceProductDescription(description));
                dispatch(setSliceProductMediaList(imageList));
                dispatch(FJActionTextToVideo.onGotoProductInfoEditAction());
                dispatch(FJActionModal.hideGenerateLoadingModalAction());
                FJUtil.eaLog('ai_product_url_analyze_complete', {
                    url: productUrlToVideoInput,
                    domain,
                    Success: true,
                    page: window.isEditPage ? 'editor' : 'tools page',
                });
            } catch (error) {
                console.log('error', error);
                FJUtil.eaLog('ai_product_url_analyze_complete', {
                    url: productUrlToVideoInput,
                    domain,
                    Success: false,
                    fail_reason: 'oops an error',
                    page: window.isEditPage ? 'editor' : 'tools page',
                });
                dispatch(this.onErrorAction('oops-an-error-occurred-please-try-again'));
            }
        };
    },
    onGotoProductInfoEditAction: function (isClear = false) {
        return async dispatch => {
            if (isClear) {
                dispatch(setSliceProductName(''));
                dispatch(setSliceProductDescription(''));
                dispatch(setSliceProductMediaList([]));
            }
            const newStepList = TEXT_TO_VIDEO_STEP_LIST.filter(
                item => item.type !== FJConstant.STEP_TYPE_SCRIPTS_PASTE,
            ).map(item => {
                if (item.type === FJConstant.STEP_TYPE_SCRIPTS_EDIT) {
                    return { ...item, name: 'product-information' };
                }
                return { ...item };
            });

            dispatch(setSliceTextToVideoStepList(newStepList));
            dispatch(setSliceTextToVideoStep(FJConstant.STEP_TYPE_SCRIPTS_EDIT));
        };
    },
    // 上传产品媒体文件
    onUploadMediaAction: function (files) {
        return async (dispatch, getState) => {
            FJUtil.eaLog('ai_product_upload_click', {
                page: window.isEditPage ? 'editor' : 'tools page',
            });
            let errorList = [];
            const filesArray = Array.from(files);
            for (let i = 0; i < filesArray.length; i++) {
                const { productMediaList } = getState().textToVideo;

                const file = filesArray[i];
                if (productMediaList.length >= 30) {
                    FJMessageStore.addMessage(FJLocalStore._('you-can-upload-up-to-30-files'), 'error');
                    return;
                }
                const isImage = FJUtil.isImage(file, true, UPLOAD_FILE_TYPE_PRODUCE_IMAGE);
                if (!isImage) {
                    errorList.push(file);
                    continue;
                }
                const fileId = await FJUtil.hashEncode(file);
                const image = await FJUtil.loadImageFileAsync(file);
                if (image) {
                    const info = {
                        url: image.src,
                        width: image.width,
                        height: image.height,
                        id: fileId,
                        type: 'IMAGE',
                        source: 'LOCAL',
                        file,
                    };
                    const newMediaList = [info, ...productMediaList];
                    dispatch(setSliceProductMediaList(newMediaList));
                } else {
                    errorList.push(file);
                }
            }
            if (errorList.length) {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
            }
        };
    },

    /**
     * @description ppt转视频生成
     * @returns
     */
    onPptToScriptAction: function () {
        return async (dispatch, getState) => {
            const { pptFile } = getState().textToVideo;
            try {
                if (!pptFile) {
                    FJMessageStore.addMessage(FJLocalStore._('please-upload-files-first'), 'error');
                    return;
                }

                dispatch(FJActionModal.showGenerateLoadingModalAction(FJLocalStore._('generating...')));
                const isLogin = await _checkLogin(dispatch);
                if (!isLogin) return;
                FJUtil.eaLog('ai_pdf_next_click', {
                    page: window.isEditPage ? 'editor' : 'tools page',
                });
                const id = await FJUtil.hashEncode(pptFile);

                const result = await _pptToVideo(pptFile, id);
                if (!result) {
                    dispatch(FJActionModal.hideGenerateLoadingModalAction());
                    return;
                }
                const sceneList = await _generatePptScript(result, id);
                dispatch(setSliceSceneTextList(sceneList));
                dispatch(FJActionModal.hideGenerateLoadingModalAction());

                const newStepList = TEXT_TO_VIDEO_STEP_LIST.filter(
                    item =>
                        item.type !== FJConstant.STEP_TYPE_SCRIPTS_PASTE &&
                        item.type !== FJConstant.STEP_TYPE_SCRIPTS_EDIT,
                );
                dispatch(setSliceTextToVideoStepList(newStepList));
                dispatch(setSliceTextToVideoStep(FJConstant.STEP_TYPE_VIDEO_SETTINGS));
            } catch (error) {
                console.log('error', error);
                dispatch(this.onErrorAction('oops-an-error-occurred-please-try-again'));
            }
        };
    },
    // 产品生成脚本
    onProductToScriptAction: function () {
        return async (dispatch, getState) => {
            const { productName, productDescription, productMediaList } = getState().textToVideo;
            FJUtil.eaLog('ai_product_next_click', {
                page: window.isEditPage ? 'editor' : 'tools page',
            });
            if (!productName || !productDescription) {
                FJMessageStore.addMessage(FJLocalStore._('please-enter-the-product-information-first'), 'error');
                return;
            }
            if (!productMediaList.length) {
                FJMessageStore.addMessage(FJLocalStore._('please-upload-product-images-or-videos-first'), 'error');
                return;
            }
            dispatch(FJActionModal.showGenerateLoadingModalAction(FJLocalStore._('generating...')));
            try {
                const isLogin = await _checkLogin(dispatch);
                if (!isLogin) return;
                const lang = await _getLanguageInfo(productDescription.substring(0, 100));
                const productNamePrompt = `${productName} \n ${productDescription}`;
                let aiLanguage = FJTranslateLanguage[lang] || lang;

                const chatData = await FJNetworkStore.getChatData({
                    prompt: productNamePrompt,
                    type: 6,
                    language: aiLanguage,
                });
                const textList = _parseGoogleArrData(chatData);
                let scriptList = _getSceneTextList(textList, lang);
                let sceneList = [];
                for (let i = 0; i < scriptList.length; i++) {
                    const item = scriptList[i];
                    let mediaItem = productMediaList[i];
                    let obj = { ...item };
                    if (mediaItem) {
                        const { id, file, source, url } = mediaItem;
                        if (source === 'LOCAL') {
                            await FJLoadLocalforageStore.setItem(id, {
                                data: file,
                                type: file.type,
                                size: file.size,
                                name: file.name,
                            });
                            obj.mediaInfo = {
                                type: 'IMAGE',
                                id,
                                source,
                            };
                        } else {
                            obj.mediaInfo = {
                                type: 'IMAGE',
                                id,
                                url,
                                source,
                            };
                        }
                    } else {
                        const getRandomMedia = FJUtil.getRandomElementFromArray(sceneList);
                        obj.mediaInfo = getRandomMedia.mediaInfo;
                    }
                    sceneList.push(obj);
                }

                dispatch(setSliceSceneTextList(sceneList));
                dispatch(FJActionModal.hideGenerateLoadingModalAction());
                dispatch(setSliceTextToVideoStep(FJConstant.STEP_TYPE_VIDEO_SETTINGS));
            } catch (error) {
                console.log('error', error);
                dispatch(this.onErrorAction('oops-an-error-occurred-please-try-again'));
            }
        };
    },
    updateUseFreeLimitAction: function (info) {
        return dispatch => {
            const freeNumCreationInfo = {
                textToScript: info[TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE.TEXT_TO_SCRIPT] || 0,
                analysisUrl: info[TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE.ANALYSIS_URL] || 0,
                textToFullVideo: info[TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE.TEXT_TO_FULL_VIDEO] || 0,
                productUrlToVideo: info[TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE.PRODUCT_URL_TO_VIDEO] || 0,
                blogUrlToVideo: info[TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE.BLOG_URL_TO_VIDEO] || 0,
                pptToVideo: info[TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE.PPT_TO_VIDEO] || 0,
            };
            dispatch(setSliceFreeNumCreationInfo(freeNumCreationInfo));
        };
    },
    // 最后一步生成
    onGenerateVideoAction: function () {
        return async (dispatch, getState) => {
            const {
                sceneTextList,
                textToImageStyle,
                ratio,
                mediaSource,
                languageValue,
                voiceValue,
                voiceStyleValue,
                voiceSpeed,
                voicePitch,
                subtitleStyle,
                voiceSettingActive,
                subtitleSettingActive,
                selectTab,
                useSpiderImage,
                spiderData,
                freeNumCreationInfo,
            } = getState().textToVideo;
            let sceneList = sceneTextList.filter(item => !!item.text.trim());
            let textArr = sceneList.map(item => item.text);
            let musicKeyword = '';
            let hsaMediaList = [];
            let isAddToEnd = false;
            const recId = FJUtil.createSimpleId();
            const generateDataId = 'textToVideoData' + recId;
            const aiToolCommunicationId = 'aiTool' + recId;
            const editCommunicationId = 'edit' + recId;
            let useFreeTimes = false;
            let isEditPageError = false;
            let isAiToolError = false;
            const tabCommunication = new FJTabCommunication();
            const _generateToEditError = () => {
                localStorage.setItem(
                    generateDataId,
                    JSON.stringify({
                        status: 'error',
                    }),
                );
                tabCommunication.stopMonitorHeartbeat();
                tabCommunication.stopHeartbeat(aiToolCommunicationId);
                isAiToolError = true;
            };
            if (!window.isEditPage) {
                // 先打开编辑页，需要被判定为用户行为才不会被阻止
                const jumpData = {
                    module: 'ai-tool-text-to-video-generate',
                    data: {
                        generateDataId,
                        editCommunicationId,
                        aiToolCommunicationId,
                    },
                };
                const data = {
                    status: 'processing',
                };
                //数据量小，使用localStorage存储
                localStorage.setItem(recId, JSON.stringify(jumpData));
                localStorage.setItem(generateDataId, JSON.stringify(data));
                let url = FJUtil.getCurrentUrl() + 'editor/app' + `?ratio=${ratio.ratioValue}&rec_id=${recId}`;
                window.open(url, '_blank');
                tabCommunication.onStorageChange(editCommunicationId, data => {
                    if (data === 'success') {
                        dispatch(FJActionModal.hideGenerateLoadingModalAction());
                        FJUtil.updateAllCreditInfo(useFreeTimes);
                        tabCommunication.stopMonitorHeartbeat();
                        // 编辑页生成失败
                        tabCommunication.stopHeartbeat(aiToolCommunicationId);
                    } else if (data === 'error' && !isAiToolError) {
                        isEditPageError = true;
                        dispatch(this.onErrorAction('oops-an-error-occurred-please-try-again'));
                        tabCommunication.stopMonitorHeartbeat();
                        tabCommunication.stopHeartbeat(aiToolCommunicationId);
                    }
                });

                tabCommunication.startHeartbeat(aiToolCommunicationId);
                //监听编辑页
                setTimeout(() => {
                    tabCommunication.monitorHeartbeat(editCommunicationId, () => {
                        dispatch(this.onErrorAction('oops-an-error-occurred-please-try-again'));
                        isEditPageError = true;
                    });
                }, 5000);
            }

            if (window.isEditPage && window.EDIT_PAGE_API) {
                const res = await window.EDIT_PAGE_API.textToVideoModeSelect();
                if (res === 'close') {
                    return;
                } else {
                    isAddToEnd = res === 'addToEnd';
                }
            }
            const _error = message => {
                dispatch(FJActionModal.hideGenerateLoadingModalAction());
                FJMessageStore.addMessage(FJLocalStore._(message), 'error');
            };
            dispatch(FJActionModal.showGenerateLoadingModalAction(FJLocalStore._('generating...')));
            // 如果选择了抓取出来的图片，则使用图片
            if (selectTab === FJAppConstant.BLOG_URL_TO_VIDEO && useSpiderImage && spiderData?.images?.length) {
                hsaMediaList = [
                    ...spiderData.images.map(item => ({
                        type: 'IMAGE',
                        url: item.url,
                        source: 'WEB',
                    })),
                ];
            }

            if (selectTab === FJAppConstant.PPT_TO_VIDEO || selectTab === FJAppConstant.PRODUCT_URL_TO_VIDEO) {
                hsaMediaList = sceneList.map(item => item.mediaInfo);
            }
            try {
                const isLogin = await _checkLogin(dispatch);
                if (!isLogin) {
                    _generateToEditError();
                    return;
                }
                if (isEditPageError) {
                    return;
                }
                // 需要实时获取积分
                await dispatch(FJActionCommon.updateUserCreditsInfoAction(true));
                if (isEditPageError) {
                    return;
                }
                const creditNumber = getState().common.creditNumber;
                const quotaInfo = this.getQuotaInfo({
                    type: this.getDeductType(selectTab),
                    textToSpeechUseLength: voiceSettingActive
                        ? FJUtil.getTextLength(sceneList.reduce((calc, cur) => calc + cur.text, ''))
                        : 0,
                    generateImageNum: Math.max(sceneList.length - hsaMediaList.length, 0),
                    mediaMatch: mediaSource === FJConstant.STOCK_LIBRARY,
                    freeNumCreationInfo,
                    creditNumber,
                });
                useFreeTimes = quotaInfo.useFreeTimes;
                FJUtil.eaLog('text_to_full_video_generate_click', {
                    generation_mode: mediaSource === FJConstant.STOCK_LIBRARY ? 'stock' : 'AI image',
                    ai_style: textToImageStyle.name,
                    tools: selectTab,
                    ratio: ratio.name,
                    voice: voiceSettingActive ? languageValue : 'none',
                    subtitle: subtitleSettingActive ? subtitleStyle.text : 'none',
                    'credit&free': useFreeTimes ? 'free' : 'credit',
                    page: window.isEditPage ? 'editor' : 'tools page',
                });
                if (!quotaInfo.isEnough) {
                    FJUtil.getCredits(FJTextToVideoStore.getAppType());
                    dispatch(FJActionModal.hideGenerateLoadingModalAction());
                    _generateToEditError();
                    return;
                }
                // 已有图片就使用已有图片，没有图片就生成图片
                if (mediaSource === FJConstant.AI_GENERATED) {
                    // 生成图片
                    const chatData = await FJNetworkStore.getChatData({
                        prompt: JSON.stringify(textArr),
                        type: 3,
                    });
                    if (!chatData) {
                        // _error('oops-an-error-occurred-please-try-again');
                        dispatch(FJActionModal.hideGenerateLoadingModalAction());
                        _generateToEditError();
                        return;
                    }
                    if (isEditPageError) {
                        return;
                    }
                    const { scene_prompt: scenePrompt, music_key } = _parseGoogleObjData(chatData);
                    musicKeyword = music_key;
                    const imgDescList = scenePrompt.slice(hsaMediaList.length);
                    if (imgDescList.length) {
                        const aiImageList = await _getImageList(imgDescList, textToImageStyle, ratio, dispatch);
                        if (!aiImageList) {
                            dispatch(FJActionModal.hideGenerateLoadingModalAction());
                            _generateToEditError();
                            return;
                        }
                        if (isEditPageError) {
                            return;
                        }
                        hsaMediaList = [...hsaMediaList, ...aiImageList];
                    }
                    sceneList = sceneList.map((item, index) => ({
                        ...item,
                        mediaInfo: hsaMediaList[index],
                    }));
                } else {
                    //获取资源搜索关键字
                    const chatData = await FJNetworkStore.getChatData({
                        prompt: JSON.stringify(textArr),
                        type: 4,
                    });
                    if (!chatData) {
                        _error('generate-keyword-failed');
                        _generateToEditError();
                        return;
                    }
                    if (isEditPageError) {
                        return;
                    }
                    const { scene_key: keywordList, music_key } = _parseGoogleObjData(chatData);
                    musicKeyword = music_key;
                    sceneList = sceneList.map((item, index) => {
                        const mediaInfo = hsaMediaList[index] || '';
                        return {
                            ...item,
                            keywordList: [keywordList[index]],
                            mediaInfo: mediaInfo,
                        };
                    });
                }

                let generateData = {
                    sceneList,
                    languageValue,
                    voiceValue,
                    voiceStyleValue,
                    voiceSpeed,
                    voicePitch,
                    subtitleStyleId: subtitleStyle.id,
                    subtitleStyleJsonUrl: subtitleStyle?.jsonUrl,
                    voiceSettingActive,
                    subtitleSettingActive,
                    musicKeyword,
                    quotaInfo,
                    isAddToEnd,
                    sceneTextLang: f_sceneTextLang,
                    disableImageAnimation: selectTab === FJAppConstant.PPT_TO_VIDEO,
                    ratioValue: ratio.ratioValue,
                    status: 'success',
                };

                if (window.isEditPage) {
                    dispatch(FJActionEditPage.applyTextToVideoAction(generateData));
                } else {
                    localStorage.setItem(generateDataId, JSON.stringify(generateData));
                }
            } catch (error) {
                console.log('error', error);
                _generateToEditError();
                dispatch(this.onErrorAction('oops-an-error-occurred-please-try-again'));
            }
            //  finally {
            //     if (!window.isEditPage) {
            //         dispatch(FJActionModal.hideGenerateLoadingModalAction());
            //     }
            // }
        };
    },

    onErrorAction: function (message) {
        return dispatch => {
            dispatch(FJActionModal.hideGenerateLoadingModalAction());
            FJMessageStore.addMessage(FJLocalStore._(message), 'error');
        };
    },

    getDeductType: appType => {
        switch (appType) {
            case FJAppConstant.TEXT_TO_FULL_VIDEO:
                return TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE.TEXT_TO_FULL_VIDEO;
            case FJAppConstant.PRODUCT_URL_TO_VIDEO:
                return TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE.PRODUCT_URL_TO_VIDEO;
            case FJAppConstant.BLOG_URL_TO_VIDEO:
                return TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE.BLOG_URL_TO_VIDEO;
            case FJAppConstant.PPT_TO_VIDEO:
                return TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE.PPT_TO_VIDEO;
        }
    },
    // 检查积分消耗
    getQuotaInfo: options => {
        const {
            type,
            textToSpeechUseLength = 0,
            generateImageNum = 0,
            mediaMatch = false,
            freeNumCreationInfo,
            creditNumber,
        } = options;
        // 向下取整三位小数
        let textToSpeechCredit = textToSpeechUseLength * (1 / TEXT_TO_VIDEO_PRICE.textToSpeech);
        let generateImageCredit = mediaMatch ? 0 : generateImageNum * TEXT_TO_VIDEO_PRICE.textToImage;
        let freeTimes = 0;
        let useFunctionPrice = 0;
        let mediaMatchCredit = 0;
        const { textToScript, textToFullVideo, analysisUrl, productUrlToVideo, blogUrlToVideo, pptToVideo } =
            freeNumCreationInfo;
        switch (type) {
            case TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE.TEXT_TO_SCRIPT:
                freeTimes = textToScript;
                useFunctionPrice = TEXT_TO_VIDEO_PRICE.textToScript;
                break;
            case TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE.ANALYSIS_URL:
                freeTimes = analysisUrl;
                useFunctionPrice = TEXT_TO_VIDEO_PRICE.analysisUrl;
                break;
            case TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE.TEXT_TO_FULL_VIDEO:
                freeTimes = textToFullVideo;
                useFunctionPrice = TEXT_TO_VIDEO_PRICE.textToFullVideo;
                mediaMatchCredit = mediaMatch ? TEXT_TO_VIDEO_PRICE.mediaMatch : 0;
                break;
            case TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE.BLOG_URL_TO_VIDEO:
                freeTimes = blogUrlToVideo;
                useFunctionPrice = TEXT_TO_VIDEO_PRICE.blogUrlToVideo;
                mediaMatchCredit = mediaMatch ? TEXT_TO_VIDEO_PRICE.mediaMatch : 0;
                break;
            case TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE.PRODUCT_URL_TO_VIDEO:
                freeTimes = productUrlToVideo;
                useFunctionPrice = TEXT_TO_VIDEO_PRICE.productUrlToVideo;
                break;

            case TEXT_TO_VIDEO_DEDUCT_ENUM_TYPE.PPT_TO_VIDEO:
                freeTimes = pptToVideo;
                useFunctionPrice = TEXT_TO_VIDEO_PRICE.pptToVideo;
                break;
        }
        //实际使用的积分
        const useCredits = generateImageCredit + useFunctionPrice + textToSpeechCredit + mediaMatchCredit;

        const isEnough = creditNumber >= useCredits || (generateImageCredit === 0 && freeTimes > 0);

        const useFreeTimes = generateImageCredit === 0 && freeTimes > 0 && useCredits > creditNumber;
        return {
            useCredits, //需要前端主动去扣除的积分
            textToSpeechCredit, //文字转语音的积分
            generateImageCredit, //生成图片的积分
            deductType: type,
            useFreeTimes, //是否使用免费次数
            isEnough, //积分是否足够
        };
    },
    initMediaSourceAction: function () {
        return async (dispatch, getState) => {
            const { freeNumCreationInfo, selectTab } = getState().textToVideo;
            const { creditNumber } = getState().common;
            if (
                ((selectTab === FJAppConstant.TEXT_TO_FULL_VIDEO && freeNumCreationInfo.textToFullVideo > 0) ||
                    (selectTab === FJAppConstant.BLOG_URL_TO_VIDEO && freeNumCreationInfo.blogUrlToVideo)) &&
                creditNumber === 0 &&
                !f_initMediaSource[selectTab]
            ) {
                dispatch(setSliceMediaSource(FJConstant.STOCK_LIBRARY));
                f_initMediaSource[selectTab] = true;
            }
            if (!f_isInitRatio[selectTab] && f_initRatio && window.isEditPage) {
                dispatch(setSliceRatio(f_initRatio));
                f_isInitRatio[selectTab] = true;
            }
        };
    },
    initFromEditPageAction: function (options) {
        return async dispatch => {
            const { appType, ratioType, updateTTVTab, videoScriptValue, source, stateForageId } = options;
            const ratio = TEXT_TO_VIDEO_RATIO_LIST.find(item => item.editRatio.includes(ratioType));
            if (ratio) {
                f_initRatio = ratio;
                dispatch(setSliceRatio(ratio));
            }
            if (appType && updateTTVTab) {
                dispatch(setSliceSelectTab(appType));
            }
            if (source === 'ai-video-script') {
                dispatch(FJActionTextToVideo.gotoPasteScriptAction());
                dispatch(setSliceScriptPasteText(videoScriptValue));
            }
            if (stateForageId) {
                const data = await localforage.getItem(stateForageId);
                if (data) {
                    localforage.removeItem(stateForageId);
                    const { selectTab, stateCache } = data;
                    f_StateCache = stateCache;
                    const newState = f_StateCache[selectTab] || defaultTextToVideoState;
                    dispatch(setSliceAll(newState));
                }
            }
        };
    },
};

export default FJActionTextToVideo;
